import * as _ from "lodash";
import {IComponentOptions, ILogService} from "angular";
import {IModalService} from "angular-ui-bootstrap";
import {LoadingService} from "../../loading/loading.service";
import {ApplicationService} from "../application.service";
import {getSecureDownloadUrl} from "../../utils/attachment-utils";

class AttachmentListController {

    public attachments: any[];
    private applicationId: string;
    private unitId: string;
    private attachmentType: string;
    private courseCode: string;

    /* @ngInject */
    constructor(private $log: ILogService,
                private $uibModal: IModalService,
                private toaster: any,
                private base64: any,
                private loadingService: LoadingService,
                private applicationService: ApplicationService) {
        this.$log.log("Attachment list for attachments: %o, type: %o", this.attachments, this.attachmentType);
    }

    public removeAttachment(attachment) {
        this.$uibModal.open({
            component: "applicationDeleteAttachmentModal",
        }).result.then(() => {
            if (this.attachmentType === "PRIOR_UNIT_ATTACHMENT") {
                this.$log.log("Removing prior unit supdoc %o", attachment);

                this.loadingService.show();
                this.applicationService.removeStudentCreditRequestUnitSupportingDocument(this.applicationId, this.unitId, this.base64.urlencode(attachment.filename))
                    .then(() => {
                        this.attachmentDeletedSuccessfully(attachment);
                    })
                    .finally(() => {
                        this.loadingService.hide();
                    });
            } else if (this.attachmentType === "APPLICATION_ATTACHMENT") {
                this.$log.log("Removing application supdoc %o", attachment);

                this.loadingService.show();
                this.applicationService.removeStudentCreditRequestSupportingDocument(this.applicationId, this.base64.urlencode(attachment.filename))
                    .then(() => {
                        this.attachmentDeletedSuccessfully(attachment);
                    })
                    .finally(() => {
                        this.loadingService.hide();
                    });
            } else if (this.attachmentType === "INTERNAL_USE_ONLY_ATTACHMENT") {
                this.$log.log("Removing internal use only attachment %o", attachment);

                this.loadingService.show();
                this.applicationService.removeStudentCreditApplicationInternalUseOnlyDocument(this.applicationId, this.base64.urlencode(attachment.filename))
                    .then(() => {
                        this.attachmentDeletedSuccessfully(attachment);
                    })
                    .finally(() => {
                        this.loadingService.hide();
                    });
            } else if (this.attachmentType === "COURSE_DOCUMENTS") {
                this.$log.log("Removing course documents %o", attachment);

                this.loadingService.show();
                this.applicationService.removeCourseDocuments(this.applicationId, this.courseCode, this.base64.urlencode(attachment.filename))
                    .then(() => {
                        this.attachmentDeletedSuccessfully(attachment);
                    })
                    .finally(() => {
                        this.loadingService.hide();
                    });
            }
        }, (reason) => {
            this.$log.info("modal dismissed: " + reason);
        });
    }

    /**
     * Generate a secure download URL that goes through the backend proxy.
     * This ensures only authenticated users can access attachments.
     */
    public getDownloadUrl(attachment): string {
        return getSecureDownloadUrl(attachment, this.base64, this.applicationId);
    }

    private attachmentDeletedSuccessfully(attachment) {
        this.toaster.pop({type: "success", title: "Attachment successfully deleted"});
        this.attachments = _.without(this.attachments, attachment);
    }
}

export const AttachmentListComponent: IComponentOptions = {
    bindings: {
        disabled: "<",
        applicationId: "<",
        attachments: "=",
        attachmentType: "<",
        unitId: "<?",
        courseCode: "<?"
    },
    controller: AttachmentListController,
    template: require("./attachment-list.html")
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/main/client/app/shared/application/attachment-list/attachment-list.component.ts